import { AccordionCardTemplate } from '../../../../components/accordion-card-template';
import { withAdditionalProps } from '../../../../hoc/with-additional-props';
import { optionallyRendered } from '../../../../hoc/optionally-rendered';
import { renderControls } from '../render-controls';

const CardTemplateWithControls = withAdditionalProps(AccordionCardTemplate, { renderControls });
const OptionallyRenderedCardTemplate = optionallyRendered(CardTemplateWithControls);

export { OptionallyRenderedCardTemplate as CardTemplate };
